import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { forkJoin, NEVER, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { DigitalLogService } from '../services/sections/job/digital-log.service';
import { DigitalLogLookupListInfo } from '../models/digital-log/digital-log.model';
import { JobDigitalLogForm, JobDigitalLogFormData } from '@vitralogy/ng-digital-log';

type ReturnType = {
	form: JobDigitalLogForm,
	lookups: DigitalLogLookupListInfo[],
	formData: JobDigitalLogFormData[]
};

@Injectable({
	providedIn: 'root'
})
export class DigitalLogFormResolver implements Resolve<Observable<ReturnType>> {

	constructor(
		private router: Router,
		private digitalLogService: DigitalLogService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		const token = activatedRouteSnapshot.paramMap.get('token');
		const jobDigitalLogFormRequestId = parseInt(activatedRouteSnapshot.paramMap.get('jobDigitalLogFormRequestId'), 10);

		if (isNaN(jobDigitalLogFormRequestId)) {
			this.router.navigate(['/404']);
			GlobalSettingsService.isSecondaryLoaderLoading = false;
			return NEVER;
		}

		return forkJoin([
			this.digitalLogService.getForm(token, jobDigitalLogFormRequestId),
			this.digitalLogService.getLookups(token, jobDigitalLogFormRequestId),
			this.digitalLogService.getData(token, jobDigitalLogFormRequestId),
			this.digitalLogService.getFieldDocuments(token, jobDigitalLogFormRequestId)
		])
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				}),
				map(([form, lookups, formData, fieldDocuments]) => {
					return { form, lookups, formData, fieldDocuments };
				})
			);
	}
}
